import Icon from '../components/Icon.vue'

Icon.register({
  'star-half': {
    width: 576,
    height: 512,
    paths: [
      {
        d: 'M288 0v439.6l-130.7 68.6c-23.4 12.3-50.9-7.6-46.4-33.7l25-145.5-105.7-103c-19-18.5-8.5-50.8 17.7-54.6l146.1-21.2 65.3-132.4c5.9-11.9 17.3-17.8 28.7-17.8z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/star-half.js
// module id = 1944
// module chunks = 0